export default {
      id: "icon-file-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-file",
      toString: function () {
        return this.url;
      }
    }